import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/cjs/styles/prism';
import { cloneDeep } from 'lodash';
import { ConfigValues } from '@MerchantConfigurator/constants';
import CopyToClipboard from '../../../../CopyToClipboard';
import styles from './ControlPanel.module.less';
import { generateMessagingCodeSnippet } from '@MerchantConfigurator/utils/messaging';

export default ({ messagingConfig, label }) => {
  const languageClass = 'pre[class*="language-"]';
  const customTheme = cloneDeep(vscDarkPlus);
  customTheme[languageClass].background = '#0D1B33';
  customTheme[languageClass].color = '#0D1B33';

  const codeSnippet = generateMessagingCodeSnippet({
    messageConfig: { ...messagingConfig, status: ConfigValues.status.enabled },
    offerType: undefined,
    productPrice: 'ENTER_VALUE_HERE'
  });

  return (
    <>
      <div className={styles.copy_icon}>
        <CopyToClipboard contentToCopy={codeSnippet} tabName={label} />
      </div>
      <SyntaxHighlighter
        style={customTheme}
        language="html"
        data-testid="codeBlock"
        showLineNumbers
      >
        {codeSnippet}
      </SyntaxHighlighter>
    </>
  );
};
